/**
 * Promise.withResolvers — Safari < 17.4 / Chrome < 119 / Firefox < 121
 * Required by pdfjs-dist v5 (react-pdf).
 */
if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers<T = unknown>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
